import React from 'react';
import { connect } from 'react-redux';
import errorIcon from '../../../../style/error.png';

class EditWarningRow extends React.PureComponent {
  state = { error: undefined }
  componentWillReceiveProps(nextProps) {
    if (this.props.errors != nextProps.errors) {
      this.parseErrors(nextProps);
    }
  }

  parseErrors = (props) => {
    let error = undefined;
    if (props.errors) {
      const values = props.errors.valueSeq().join(', ');
      if (values.lastIndexOf('be empty') > values.indexOf('be empty')) {
        error = 'You have not entered the required fields.';
      } else if (values.indexOf('be empty') >= 0) {
        error = 'You have not entered the required field.';
      } else if (values.indexOf('should be unique') >= 0) {
        error = 'Name should should be unique.';
      }
    }
    this.setState({ error });
  }

  render() {
    if (this.state.error) {
      return (<div className={'reference-warning-row'}>
        <div className={'container'}><img
          src={errorIcon} alt={'edit'} title={'edit'} className={'payments-table-small-icon'}
        />
        {this.state.error}
        </div>
      </div>);
    }
    return null;
  }
}
export default connect(state => ({
  errors: state.get('error'),
}))(EditWarningRow);
